import { useInView } from "../hooks/useInView";
import { cn } from "../lib/utils";

const Reveal = ({ children, className, delay = 0, as: Tag = "div" }) => {
  const { ref, inView } = useInView();

  return (
    <Tag
      ref={ref}
      className={cn("reveal", inView && "is-visible", className)}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </Tag>
  );
};

export default Reveal;